import { useLang } from '@/i18n';
import EfSection from 'elem/ui/ef-section';
import EfSpec from 'elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionG');

    const configs = {
        hasAnimation: false,
        title: t('title'),
        desc: t.rich('desc', {
            sup: (tx: string) => <sup>{tx}</sup>,
        }),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1737009896394/whisper.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1737009900632/whisper_m.jpg',
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection {...configs} />
        </div>
    );
}
